import * as React from 'react'

export const LambdaSVG = () => {
  return (
    <svg
      width="322px"
      height="349px"
      viewBox="0 0 322 349"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-250.000000, -491.000000)"
          fill="#A0001E"
          fillRule="nonzero"
        >
          <g id="lambda-logo" transform="translate(240.000000, 486.000000)">
            <g id="HtmlToSvg">
              <g id="Group" transform="translate(65.599520, 66.557350)">
                <polyline
                  id="Path"
                  points="81.6482664 0.56918015 1.85790874 143.252414 46.8334708 143.252414 105.449442 37.350808 164.065413 143.252414 209.043599 143.252414 129.250618 0.56918015 81.6482664 0.56918015"
                />
              </g>
              <g id="Group" transform="translate(7.867893, 3.606550)">
                <path
                  d="M2.53756745,1.70229455 L2.53756745,235.855664 L162.7717,349.675956 L323.827196,235.275992 L323.827196,1.70229455 L2.53756745,1.70229455 M162.7717,304.052364 L40.183837,217.035998 L40.183837,38.1691684 L286.251779,38.1691684 L286.251779,216.453703 L162.7717,304.052364"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const PineneedlesSVG = ({ width = 720, height = 245, style = {} }) => {
  return (
    <div style={style}>
      <svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox={`0 0 ${width * 2} ${height * 2}`}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path
            d="M417.2,277.8 L377.3,277.8 L377.3,73.2 L416,73.2 L416,91.2 C422.6,79.8 439.1,69.9 461.3,69.9 C504.5,69.9 529.4,102.9 529.4,146.7 C529.4,191.4 501.5,224.4 459.8,224.4 C439.4,224.4 424.4,216.3 417.2,206.4 L417.2,277.8 Z M490.1,147 C490.1,120.9 473.9,105.6 453.5,105.6 C433.1,105.6 416.6,120.9 416.6,147 C416.6,173.1 433.1,188.7 453.5,188.7 C473.9,188.7 490.1,173.4 490.1,147 Z M593.981815,220.8 L554.081815,220.8 L554.081815,73.2 L593.981815,73.2 L593.981815,220.8 Z M549.281815,24.9 C549.281815,11.1 560.381815,1.13686838e-13 573.881815,1.13686838e-13 C587.681815,1.13686838e-13 598.481815,11.1 598.481815,24.9 C598.481815,38.1 587.681815,49.2 573.881815,49.2 C560.381815,49.2 549.281815,38.1 549.281815,24.9 Z M669.66363,135.9 L669.66363,220.8 L629.76363,220.8 L629.76363,73.2 L668.46363,73.2 L668.46363,91.5 C677.46363,76.2 695.16363,69.3 711.06363,69.3 C747.66363,69.3 764.46363,95.4 764.46363,127.8 L764.46363,220.8 L724.56363,220.8 L724.56363,134.7 C724.56363,118.2 716.46363,105.3 697.26363,105.3 C679.86363,105.3 669.66363,118.8 669.66363,135.9 Z M827.245445,130.2 L893.245445,130.2 C892.645445,115.5 883.045445,101.1 860.245445,101.1 C839.545445,101.1 828.145445,116.7 827.245445,130.2 Z M897.145445,168.6 L930.445445,178.5 C922.945445,204 899.545445,225.3 863.245445,225.3 C822.745445,225.3 787.045445,196.2 787.045445,146.4 C787.045445,99.3 821.845445,68.7 859.645445,68.7 C905.245445,68.7 932.545445,97.8 932.545445,145.2 C932.545445,150.9 931.945445,156.9 931.945445,157.5 L826.345445,157.5 C827.245445,177 843.745445,191.1 863.545445,191.1 C882.145445,191.1 892.345445,181.8 897.145445,168.6 Z M417.2,375.9 L417.2,460.8 L377.3,460.8 L377.3,313.2 L416,313.2 L416,331.5 C425,316.2 442.7,309.3 458.6,309.3 C495.2,309.3 512,335.4 512,367.8 L512,460.8 L472.1,460.8 L472.1,374.7 C472.1,358.2 464,345.3 444.8,345.3 C427.4,345.3 417.2,358.8 417.2,375.9 Z M574.781815,370.2 L640.781815,370.2 C640.181815,355.5 630.581815,341.1 607.781815,341.1 C587.081815,341.1 575.681815,356.7 574.781815,370.2 Z M644.681815,408.6 L677.981815,418.5 C670.481815,444 647.081815,465.3 610.781815,465.3 C570.281815,465.3 534.581815,436.2 534.581815,386.4 C534.581815,339.3 569.381815,308.7 607.181815,308.7 C652.781815,308.7 680.081815,337.8 680.081815,385.2 C680.081815,390.9 679.481815,396.9 679.481815,397.5 L573.881815,397.5 C574.781815,417 591.281815,431.1 611.081815,431.1 C629.681815,431.1 639.881815,421.8 644.681815,408.6 Z M733.86363,370.2 L799.86363,370.2 C799.26363,355.5 789.66363,341.1 766.86363,341.1 C746.16363,341.1 734.76363,356.7 733.86363,370.2 Z M803.76363,408.6 L837.06363,418.5 C829.56363,444 806.16363,465.3 769.86363,465.3 C729.36363,465.3 693.66363,436.2 693.66363,386.4 C693.66363,339.3 728.46363,308.7 766.26363,308.7 C811.86363,308.7 839.16363,337.8 839.16363,385.2 C839.16363,390.9 838.56363,396.9 838.56363,397.5 L732.96363,397.5 C733.86363,417 750.36363,431.1 770.16363,431.1 C788.76363,431.1 798.96363,421.8 803.76363,408.6 Z M1004.54545,243.6 L1004.54545,434.1 C1004.54545,444 1005.14544,454.8 1005.74545,460.8 L967.645445,460.8 C967.045445,457.8 966.145445,450.6 966.145445,443.7 C959.545445,455.4 944.545445,464.4 924.745445,464.4 C882.745445,464.4 852.745445,431.4 852.745445,386.7 C852.745445,343.5 881.845445,309.6 923.545445,309.6 C949.045445,309.6 961.045445,320.1 965.245445,327.9 L965.245445,243.6 L1004.54545,243.6 Z M892.945445,386.7 C892.945445,413.1 908.545445,428.7 929.545445,428.7 C949.945445,428.7 965.845445,413.1 965.845445,386.4 C965.845445,360 949.945445,345.3 929.545445,345.3 C909.145445,345.3 892.945445,360.3 892.945445,386.7 Z M1080.82726,460.8 L1040.92726,460.8 L1040.92726,243.6 L1080.82726,243.6 L1080.82726,460.8 Z M1145.70908,370.2 L1211.70908,370.2 C1211.10907,355.5 1201.50907,341.1 1178.70908,341.1 C1158.00907,341.1 1146.60907,356.7 1145.70908,370.2 Z M1215.60907,408.6 L1248.90908,418.5 C1241.40908,444 1218.00907,465.3 1181.70908,465.3 C1141.20908,465.3 1105.50907,436.2 1105.50907,386.4 C1105.50907,339.3 1140.30908,308.7 1178.10907,308.7 C1223.70908,308.7 1251.00907,337.8 1251.00907,385.2 C1251.00907,390.9 1250.40908,396.9 1250.40908,397.5 L1144.80908,397.5 C1145.70908,417 1162.20908,431.1 1182.00907,431.1 C1200.60907,431.1 1210.80908,421.8 1215.60907,408.6 Z M1263.09089,419.7 L1297.29089,412.2 C1298.19089,423.9 1306.89089,434.7 1324.29089,434.7 C1337.49089,434.7 1343.79089,427.8 1343.79089,420 C1343.79089,413.4 1339.29089,408 1327.89089,405.6 L1308.39089,401.1 C1279.89089,394.8 1266.99089,377.7 1266.99089,357 C1266.99089,330.6 1290.39089,308.7 1322.19089,308.7 C1364.19089,308.7 1378.29089,335.4 1380.09089,351.3 L1346.79089,358.8 C1345.59089,350.1 1339.29089,339 1322.49089,339 C1311.99089,339 1303.59089,345.3 1303.59089,353.7 C1303.59089,360.9 1308.99089,365.4 1317.09089,366.9 L1338.09089,371.4 C1367.19089,377.4 1381.89089,395.1 1381.89089,416.7 C1381.89089,440.7 1363.29089,465.3 1324.59089,465.3 C1280.19089,465.3 1264.89089,436.5 1263.09089,419.7 Z"
            id="path-1"
          />
        </defs>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Artboard"
            transform="translate(-8.000000, -8.000000)"
            fillRule="nonzero"
          >
            <g
              id="lambda-logo-outlines"
              transform="translate(-2.000000, 8.200000)"
            >
              <g
                id="lambda-logo"
                transform="translate(0.000000, 67.800000)"
                fill="#A0001E"
              >
                <g id="HtmlToSvg">
                  <g id="Group" transform="translate(65.569150, 66.557350)">
                    <polyline
                      id="Path"
                      points="81.6104663 0.56918015 1.8570486 143.252414 46.8117887 143.252414 105.400623 37.350808 163.989457 143.252414 208.94682 143.252414 129.190779 0.56918015 81.6104663 0.56918015"
                    />
                  </g>
                  <g id="Group" transform="translate(7.864250, 3.606550)">
                    <path
                      d="M2.53639265,1.70229455 L2.53639265,235.855664 L162.696343,349.675956 L323.677276,235.275992 L323.677276,1.70229455 L2.53639265,1.70229455 M162.696343,304.052364 L40.1652333,217.035998 L40.1652333,38.1691684 L286.119255,38.1691684 L286.119255,216.453703 L162.696343,304.052364"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <g id="pineneedles">
                <use fill="#3E3934" xlinkHref="#path-1" />
                <use fill="#393D3F" xlinkHref="#path-1" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}
